module.exports = __webpack_public_path__ + "static/water_garden_bottom_bg-ba268949a62299c781bcf42f493f3484.svg";